import React, { FC, HTMLAttributes } from "react";
import styled, { css } from "styled-components";
import Headline from "./Headline";
import SeeMore from "components/front/motion/SeeMore";
import { useDispatch } from "react-redux";
import { AnimefurusatoOperations } from "modules/pages/lp/animefurusato/operations";

export type Props = HTMLAttributes<HTMLDivElement>;
const FaqArea: FC<Props> = ({ ...props }) => {
  const dispatch = useDispatch();
  const onNavigateDeductionFlowDetail = () => dispatch(AnimefurusatoOperations.navigateDeductionFlowDetail());
  return (
    <Root {...props}>
      <StyledHeadline image={{ pc: "/faq/mascot-pc.png", sp: "/faq/mascot-sp.png", position: "right" }}>
        ＼最後に！／
        <br />
        よくある質問をチェック♪
      </StyledHeadline>
      <FaqList>
        <SeeMore threshold={200} color="white">
          <FaqRow>
            <Question>収入がない場合でも利用できますか？（例：学生など）</Question>
            <Answer>
              利用することは可能ですが税金の控除を受けることが出来ません。
              <br />
              ご家族やご親戚にお願いし、代わりに寄附をお願いすることをおすすめ致します。
            </Answer>
          </FaqRow>
          <FaqRow>
            <Question>税額控除で注意すべきことはございますか？</Question>
            <Answer>
              税額控除は、所得税や住民税を納めている方が対象となります。
              <br />
              税金控除を受けるためには、ご家族の中で所得税や住民税を納めている方が応援していただけるようにご注意ください。
              <br />
              税額控除を受けるためには、寄附後に手続きが必要になりますのでご注意ください。
              <br />
              手続きについては<LinkText onClick={onNavigateDeductionFlowDetail}>こちら</LinkText>をご確認ください。
            </Answer>
          </FaqRow>
          <FaqRow>
            <Question>初めてふるさと納税をします。手続きが難しい印象です。自分でもできるのでしょうか？</Question>
            <Answer>
              インターネットで申込から決済まで完了！面倒なイメージのある申請もカンタンな手続き（ワンストップ特例制度）が用意されていますのでご安心ください。
              <br />
              手続きについては<LinkText onClick={onNavigateDeductionFlowDetail}>こちら</LinkText>をご確認ください。
            </Answer>
          </FaqRow>
          <FaqRow>
            <Question>間違えてを応援(寄附)してしまいました。キャンセルや変更はできますか？</Question>
            <Answer>
              申し訳ございません。キャンセルや変更はできません。
              <br />
              応援いただく際は返礼品のご確認をお願いいたします。
            </Answer>
          </FaqRow>
          <HelpLinkArea>
            <HelpLink href="https://animefund.zendesk.com/hc/ja/categories/900000172886" target="_blank">その他よくある質問はこちら»</HelpLink>
          </HelpLinkArea>
        </SeeMore>
      </FaqList>
    </Root>
  );
};
export default FaqArea;

const Root = styled.div``;
const StyledHeadline = styled(Headline)`
  margin: 20px 0;
`;
const FaqList = styled.div`
  padding: 14px;
  background-color: #fff;
  color: #1a1a1a;
`;
const faqContainerCss = css`
  @media screen and (min-width: 961px) {
    max-width: 600px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1441px) {
    max-width: 800px;
    margin: 0 auto;
  }
`;
const FaqRow = styled.div`
  border-bottom: 1px solid #ccc;
  ${faqContainerCss};
`;
const HelpLinkArea = styled.div`
  ${faqContainerCss};
  font-size: 14px;
  padding: 10px 0;
  text-align: right;
`;
const HelpLink = styled.a`
  text-decoration: underline;
  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
  @media screen and (min-width: 961px) {
    font-size: 14px;
  }
`;
const Question = styled.div`
  margin: 14px 0 14px 30px;
  position: relative;
  line-height: 1.428em;

  &:before {
    color: #ff0000;
    content: "Q.";
    font-size: 1.375rem;
    position: absolute;
    left: -1.4em;
    top: -0.2em;
  }
`;
const Answer = styled.div`
  margin: 14px 0 14px 30px;
  position: relative;
  line-height: 1.428em;
  font-size: 0.86em;

  &:before {
    color: #0000ff;
    content: "A.";
    font-size: 1.375rem;
    position: absolute;
    left: -1.4em;
    top: -0.2em;
  }
`;
const LinkText = styled.a`
  color: #0000ff;
  text-decoration: underline;
  cursor: pointer;
`;
